import { render, staticRenderFns } from "./stats_section.vue?vue&type=template&id=acc06fe6&scoped=true"
import script from "./stats_section.vue?vue&type=script&lang=js"
export * from "./stats_section.vue?vue&type=script&lang=js"
import style0 from "./stats_section.vue?vue&type=style&index=0&id=acc06fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc06fe6",
  null
  
)

export default component.exports